module.exports = __webpack_public_path__ + "media/images/proof_links/colored/soundcloud-4cd27db4889f93537fd2407d92712e69.svg";